export function getInfoNavigator () {
  return new Promise((resolve, reject) => {
    const infoNavigator = {
      appCodeName: navigator.appCodeName,
      appName: navigator.appName,
      appVersion: navigator.appVersion,
      platform: navigator.platform,
      userAgent: navigator.userAgent
    }
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(position => {
        infoNavigator.geolocationPositionLatitude = position.coords.latitude
        infoNavigator.geolocationPositionLongitude = position.coords.longitude
        resolve(infoNavigator)
      }, () => {
        infoNavigator.geolocationPositionLatitude = ''
        infoNavigator.geolocationPositionLongitude = ''
        resolve(infoNavigator)
      })
    }
  })
}



// WEBPACK FOOTER //
// ./src/helpers/navigator.js